"use client";

import React from "react";
import Slider from "react-slick";
import Image from "next/image";
import "./style.css";
import { Typography } from "../typography";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  appendDots: (dots: AnyType) => (
    <div className="mt-4">
      <ul className="flex justify-center space-x-2">{dots}</ul>
    </div>
  ),
};

const features = [
  {
    id: "feature1",
    icon: "/img/products.svg",
    title: "Wide Product Selection",
    description: "A vast range of quality products for every need.",
  },
  {
    id: "feature2",
    icon: "/img/quality.svg",
    title: "Quality Assurance",
    description: "Strict quality checks for your peace of mind.",
  },
  {
    id: "feature3",
    icon: "/img/pricing.svg",
    title: "Competitive Pricing",
    description: "Affordable prices with no hidden costs.",
  },
  {
    id: "feature4",
    icon: "/img/shipping.svg",
    title: "Fast and Reliable Shipping",
    description: "Quick and dependable delivery every time.",
  },
  {
    id: "feature5",
    icon: "/img/support.svg",
    title: "Exceptional Customer Support",
    description: "Friendly assistance whenever you need it.",
  },
];

export const FeaturesSlider = () => (
  <div className="bg-pageBg">
    <div className="bg-[#E5FDFF] pt-12 pb-20 mb-4 text-black">
      <div className="container mx-auto px-4">
        <Slider {...settings}>
          {features.map((feature) => (
            <div
              key={feature.id}
              className="!flex items-start text-center px-4 gap-5"
            >
              <div className="flex items-center justify-center w-24">
                <Image
                  src={feature.icon}
                  alt={`${feature.title} Icon`}
                  width={50}
                  height={50}
                  className="size-24"
                />
              </div>
              <div className="flex flex-col mt-2">
                <Typography
                  tag="h3"
                  className="text-2xl font-semibold mb-2 mt-0"
                >
                  {feature.title}
                </Typography>
                <Typography tag="p" className="text-base my-0">
                  {feature.description}
                </Typography>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>
);

export default FeaturesSlider;
